import { Language } from "../types";
import translate_DE from "./de_DE";
import translate_EN from "./en_UK";
import translate_IT from "./it_IT";

export default function getTranslate (lang: Language){
    switch(lang){
        case 'de': return translate_DE;
        case 'it': return translate_IT;
        case 'en': return translate_EN;
    }
}